// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-list-wrapper .table-container .column-select .modal-opener {
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/dataSelectionTable/src/dataSelectionTable.vue","webpack://./dataSelectionTable.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;ACDF","sourcesContent":["\n\n.table-list-wrapper .table-container .column-select .modal-opener {\n  margin-bottom: 4px;\n}\n",".table-list-wrapper .table-container .column-select .modal-opener {\n  margin-bottom: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
